<h1 class="title">{{ actionType | titlecase }} Team Member</h1>

<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>

<form [formGroup]="editForm" class="details-page-edit-form">
  @if (actionType === 'add') {
    <div class="mb-8">
      <div class="flex gap-4 mb-4">
        <button
          type="button"
          rktButton
          [btnType]="addMode === 'create' ? 'primary' : 'secondary'"
          (click)="addMode = 'create'; resetForm()"
        >
          Create New
        </button>
        <button
          type="button"
          rktButton
          [btnType]="addMode === 'search' ? 'primary' : 'secondary'"
          (click)="addMode = 'search'; resetForm()"
        >
          Add Existing
        </button>
      </div>
    </div>
  }

  @if (addMode === 'create' || actionType === 'edit') {
    <rkt-form [form]="editForm" [fields]="formFields" [model]="profileModel"></rkt-form>

    @if (shouldShowLimitField) {
      <div class="rkt-form">
        <div class="rkt-form-row-group">
          <div class="rkt-form-row">
            <div class="rkt-form-control half-row-field">
              <label class="rkt-form-label">Single Transaction Limit</label>
              <app-limit-edit-item-field
                [maxAmountValue]="baLimit || 999999999"
                limitType="single"
                [maxLimitLabel]="baLimit ? 'Business Account limit (' + baCurrency + ' ' + (baLimit | number: '1.2-2') + ')' : undefined"
                [initialValue]="limitValue"
                (changed)="setLimitAmountValue($event)"
                (errored)="onLimitAmountValueError($event)"
              ></app-limit-edit-item-field>
            </div>
          </div>
        </div>
      </div>
    }
  }

  @if (addMode === 'search' && actionType === 'add') {
    <div class="mb-8" [class.opacity-50]="isLoading" [class.pointer-events-none]="isLoading">
      <rkt-form [form]="searchForm" [fields]="searchFormFields" [model]="{ email: searchEmail.value }"></rkt-form>
    </div>

    @if (hasSearched) {
      <div class="mb-4" [class.opacity-50]="isLoading" [class.pointer-events-none]="isLoading">
        <rkt-table
          [rows]="searchResults"
          [columns]="searchTableColumns"
          [limit]="searchPageSize"
          [count]="totalSearchResults"
          (fetchData)="searchEmployees($event)"
          [loadingIndicator]="isSearching || isLoading"
          [offset]="searchPage"
          [messages]="{ emptyMessage: 'No users found with this email address.' }"
          (colButtonClicked)="onTableButtonClick($event)"
          emptyValuePlaceholder="--"
          [placeholderItemsCount]="5"
          [isClickable]="false"
          [isInteractive]="false"
        ></rkt-table>
      </div>
    }
  }

  @if (actionType === 'add' && addMode === 'create') {
    <div class="note-container">
      <app-note-form-item [errors]="note.errors" [value]="note.value">
        <textarea
          class="note-field"
          #noteField
          (blur)="onNoteFieldBlur()"
          name="new-note"
          id="new-note"
          [formControl]="note"
          maxlength="1000"
        ></textarea>
      </app-note-form-item>
    </div>
  }

  @if (userExistError) {
    <div class="mt-4 flex flex-col py-4 rounded-md items-center bg-[#f0f6f6]">
      <div class="mb-3 text-red-600">A user with this e-mail already exists - would you like to add them instead?</div>
      <div class="flex gap-4">
        <button rktButton type="button" btnType="tertiary" (click)="resetForm()">Cancel</button>
        <button rktButton type="button" btnType="primary" (click)="linkEmployeeToBusinessAccount()" [disabled]="isLoading">
          Add Existing User
        </button>
      </div>
    </div>
  }

  @if (userAlreadyLinked) {
    <div class="mt-4 flex flex-col py-4 rounded-md items-center bg-[#f0f6f6]">
      <div class="mb-3">This user is already linked to your business account.</div>
      <div class="flex gap-4">
        <button rktButton type="button" btnType="primary" (click)="resetForm()">OK</button>
      </div>
    </div>
  }

  @if (submitError) {
    <div class="details-page-edit-form-error">{{ submitError }}</div>
  }

  <div class="buttons">
    <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
    @if (addMode === 'create' || actionType === 'edit') {
      <button rktButton type="submit" (click)="onSave()" [disabled]="isLoading || editForm.invalid">Save</button>
    }
  </div>
</form>
